import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useLearnSummaryPageQueryOptions } from "#use-learn-summary-page-query-options";
import { useCallback } from "react";

function useNavigator() {
  const learnSummaryPageQueryOptions = useLearnSummaryPageQueryOptions();

  return useCallback(
    () => ({
      href: {
        pathname: "/(nav)/(app)/learn/summary",
      },
      queries: [learnSummaryPageQueryOptions],
    }),
    [learnSummaryPageQueryOptions],
  );
}

export const useLearnSummaryPageNavigator = createPageNavigator<void>({
  useNavigator,
});
